// @flow
import React, { useEffect } from "react";
import { connect } from "react-redux";
import SelectInput from "../../../comum/SelectInput";
import {
  type ActionCreator,
  getIndicesEBenchmarksPersonalizados,
} from "../../../../state";
import { type Indice } from "../../../../model";

type Props = {
  listaIndicesEBenchmarksPersonalizados: Array<Indice>,
  indiceSelecionado: string,
  onChange: any => any,
  size: number,
  multiple: boolean,
  campoDescricao: string,
  campoId: string,
  selecionarPrimeiroIndice: ActionCreator,
  selecionarIndice: ActionCreator,
  labelSelecao: string,
};

function SelecaoIndicesEBenchmarksPersonalizados({
  listaIndicesEBenchmarksPersonalizados,
  indiceSelecionado,
  onChange,
  size,
  multiple,
  campoDescricao,
  campoId,
  selecionarPrimeiroIndice,
  selecionarIndice,
  labelSelecao,
}: Props) {
  useEffect(() => {
    if (!indiceSelecionado) {
      selecionarPrimeiroIndice();
    }
  }, [indiceSelecionado, selecionarPrimeiroIndice]);

  function getDatasIndiceSelecionado(indiceSelecionado: string): string {
    if (indiceSelecionado) {
      let indice: ?Indice = listaIndicesEBenchmarksPersonalizados.find(
        indice => indice.nome === indiceSelecionado
      );
      return indice ? indice.datas : "";
    }
    return "";
  }

  return (
    <div className="ConfiguracaoMedida">
      <label className="ConfiguracaoMedida__label">
        {labelSelecao}
        <span className="ConfiguracaoMedida__label--sub">
          {getDatasIndiceSelecionado(indiceSelecionado)}
        </span>
      </label>
      <SelectInput
        alwaysOpen={true}
        portal={false}
        options={listaIndicesEBenchmarksPersonalizados}
        value={indiceSelecionado}
        onChange={onChange}
        size={size}
        multiple={multiple}
        campoDescricao={campoDescricao}
        campoId={campoId}
      />
    </div>
  );
}

SelecaoIndicesEBenchmarksPersonalizados.defaultProps = {
  campoId: "nome",
  campoDescricao: "nomeTraduzido",
  size: 6,
  multiple: false,
};

export default connect(
  state => ({
    listaIndicesEBenchmarksPersonalizados: getIndicesEBenchmarksPersonalizados(
      state
    ),
  }),
  {}
)(SelecaoIndicesEBenchmarksPersonalizados);
